import axios from './axios';

export const productsAPI = {
  getAll: async (params = {}) => {
    try {
      console.log('[ProductsAPI] Fetching products with params:', params);
      const response = await axios.get('/products', { params });
      console.log('[ProductsAPI] Products fetched:', response.data?.length || 0);
      return response.data;
    } catch (error) {
      console.error('[ProductsAPI] Error fetching products:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      console.log('[ProductsAPI] Fetching product:', id);
      const response = await axios.get(`/products/${id}`);
      console.log('[ProductsAPI] Product fetched:', response.data?.title);
      return response.data;
    } catch (error) {
      console.error('[ProductsAPI] Error fetching product:', error);
      throw error;
    }
  },

  getCategories: async () => {
    try {
      console.log('[ProductsAPI] Fetching categories');
      const response = await axios.get('/categories');
      console.log('[ProductsAPI] Categories fetched:', response.data?.length || 0);
      return response.data;
    } catch (error) {
      console.error('[ProductsAPI] Error fetching categories:', error);
      throw error;
    }
  },
};